// extracted by css-extract-rspack-plugin
export default {"pureLink":"product-detail-fragment__PureLink_pureLink__G0LVq"};